import '../styles/toast.css';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export class ToastManager {
    private static container: HTMLElement | null = null;
    private static readonly DURATION = 3500;

    private static init() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'toast-container';
            document.body.appendChild(this.container);
        }
        return this.container;
    }

    static show(message: string, type: ToastType = 'info') {
        const container = this.init();
        const toast = document.createElement('div');
        toast.className = `toast toast-${type}`;
        
        // Icon handling based on type using Iconify
        let icon = '';
        switch (type) {
            case 'success': icon = 'solar:check-circle-bold'; break;
            case 'error': icon = 'solar:danger-circle-bold'; break;
            case 'warning': icon = 'solar:danger-bold'; break;
            case 'info': icon = 'solar:info-circle-bold'; break;
        }

        toast.innerHTML = `
            <div class="toast-icon">
                <iconify-icon icon="${icon}" width="20"></iconify-icon>
            </div>
            <div class="toast-message">${message}</div>
        `;

        container.appendChild(toast);

        // Trigger animation
        requestAnimationFrame(() => {
            toast.classList.add('show');
        });

        // Auto remove
        setTimeout(() => {
            toast.classList.remove('show');
            setTimeout(() => {
                if (toast.parentNode === container) {
                    container.removeChild(toast);
                }
                // We don't remove the container anymore to keep it global
            }, 400); 
        }, this.DURATION);
    }

    static success(message: string) {
        this.show(message, 'success');
    }

    static error(message: string) {
        this.show(message, 'error');
    }

    static info(message: string) {
        this.show(message, 'info');
    }
    
    static warning(message: string) {
        this.show(message, 'warning');
    }
}
